var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.40041V14.801L5.31203 15.833C5.1636 16.0557 4.83644 16.0557 4.688 15.833L4 14.801V9.40041C4.66005 9.53322 5.33995 9.53322 6 9.40041V9.40041ZM5 0C7.48528 0 9.5 2.01472 9.5 4.5C9.5 6.98528 7.48528 9 5 9C2.51472 9 0.5 6.98528 0.5 4.5C0.5 2.01472 2.51472 0 5 0ZM2.5 4.25C2.5 3.00935 3.50935 2 4.75 2C4.81631 2 4.87989 1.97366 4.92678 1.92678C4.97366 1.87989 5 1.8163 5 1.75C5 1.6837 4.97366 1.62011 4.92678 1.57322C4.87989 1.52634 4.81631 1.5 4.75 1.5C3.23366 1.5 2 2.73366 2 4.25C2 4.31631 2.02634 4.37989 2.07322 4.42678C2.12011 4.47366 2.1837 4.5 2.25 4.5C2.3163 4.5 2.37989 4.47366 2.42678 4.42678C2.47366 4.37989 2.5 4.31631 2.5 4.25Z",
    fill: "#0D61FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.daff7be4fb4d742c1ac251c76880ef5e.svg";
export { ForwardRef as ReactComponent };